import { useState, useRef, useEffect } from 'react'
import { DataTable } from './DataTable'
import { Form, Button, message, Upload, Image, Modal } from 'antd'
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhBox } from '@/components/YhBox'
import { YHRightModal } from "@/components/YHRightModal";
import { YhForm } from "@/components/YhFormBox";
import { totalModel } from './totalModel'
import { settleService } from '../../settleService'
import FontIcon from "@/components/YhIcon";

export const DataBox = () => {

    const {
        mode, setMode,
        loadData, dataSource,
        visible, setVisible,
        setFormInfo, formInfo,
        getOne, uploadFileList,
        selectedRowKeys,
    } = totalModel()

    const formRef = useRef<IYhFormRef>();
    const [form] = Form.useForm();

    const [footerVisible, setFooterVisible] = useState<boolean>(false)
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    useEffect(() => {
        if (visible) {
            getOne(selectedRowKeys[0]);
        }
    }, [visible])

    const action = (
        <>
            <Button
                shape="round"
                type="primary"
                onClick={() => {
                    if (selectedRowKeys.length == 0) {
                        message.warning("请选择需要审核的数据！")
                        return
                    }
                    const selectedData = dataSource.filter(e => e.id == selectedRowKeys[0])
                    if (selectedData.length > 0 && selectedData[0].status === 0) {
                        setFooterVisible(true);
                        setMode("update");
                    }
                    else {
                        setMode("look");
                    }
                    setVisible(true);
                }}>
                审核
            </Button>
        </>
    )

    const onChange = (changedValues: { [key: string]: any }) => {
        setFormInfo({ ...formInfo, ...changedValues });
    }

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        formValues: formInfo,
        onChange,
        items: [
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '结算账单信息',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item>
                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>结算账单信息</span>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账单编号",
                fieldName: "code",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "加盟商名称",
                fieldName: "partnerName",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工单数量",
                fieldName: "num",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账单金额",
                fieldName: "billAmount",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '账单发票信息',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item>
                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>账单发票信息</span>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票号码",
                fieldName: "invoiceNum",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票日期",
                fieldName: "invoiceTime",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票单位",
                fieldName: "customerName",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收票单位",
                fieldName: "supplierName",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeName",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "税率",
                fieldName: "invoiceTax",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票金额",
                fieldName: "invoiceAmount",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票备注",
                fieldName: "invoiceNote",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审核意见",
                fieldName: "auditAdvise",
                labelCol: { span: 3 },
                span: 24,
                disable: mode == 'update' ? false : true
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "发票",
                fieldName: "file",
                span: 24,
                formItem: (
                    <Form.Item
                        name="fileList"
                        labelCol={{ span: 3 }}
                        label="附件">
                        <Upload
                            name="file"
                            disabled={true}
                            fileList={uploadFileList}
                            iconRender={(file) => {
                                if (file?.type?.indexOf('image') !== -1) return <><Image style={{ width: 24 }} src={file.thumbUrl} /></>
                                if (file?.type?.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                                if (file?.type?.indexOf('msword') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-doc" />
                            }}
                            onPreview={(file) => {
                                if (file?.type?.indexOf("pdf") != -1 || file?.type?.indexOf("doc") != -1) {
                                    window.location.href = file?.url ?? "";
                                }
                                else {
                                    setPreviewImage(file?.url ?? "");
                                    setPreviewOpen(true);
                                }
                            }}
                        >
                        </Upload>
                    </Form.Item >
                ),
            },
        ]
    };

    const audit = async (success: boolean) => {
        const selectedData = dataSource.filter(e => e.id == selectedRowKeys[0])
        const billInvoiceList = selectedData[0]?.billInvoiceList;
        if (billInvoiceList.length < 1) {
            message.error("账单还未上传发票")
            return;
        }

        if (success) {
            const status = formInfo.status;
            if (status != 0) {
                message.error("该账单初始状态，不能审核")
                return;
            }
            Modal.confirm({
                title: '通过',
                centered: true,
                closable: true,
                content: <div>确定要审核通过账单？</div>,
                onOk() {
                    const params = {
                        id: selectedRowKeys[0],
                        status: 3,
                        auditAdvise: formInfo.auditAdvise
                    }
                    settleService.audit(params).then((res) => {
                        if (res && res.success) {
                            loadData();
                            message.success("操作成功")
                        }
                        else {
                            message.error("操作失败")
                        }
                        setVisible(false);
                    }).catch((err) => {
                        message.error("请求失败" + err)
                    })
                },
            })

        }
        else {
            Modal.confirm({
                title: '重新发起',
                centered: true,
                closable: true,
                content: <div>确定要重新发起(清空发票信息)？</div>,
                onOk() {
                    settleService.deleteInvoice(billInvoiceList[0].id).then((res) => {
                        if (res && res.success) {
                            loadData();
                            message.success("操作成功")
                        }
                        else {
                            message.error("操作失败")
                        }
                        setVisible(false);
                    }).catch((err) => {
                        message.error("请求失败" + err)
                    })
                },
            })
        }
    }

    return (
        <>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>

            <YHRightModal
                visible={visible}
                onOk={() => setVisible(false)}
                onCancel={() => { setVisible(false); setFooterVisible(false); }}
                title="付款审核详情"
                width={800}
                showFooter={footerVisible}
                footerButs={[
                    <Button onClick={() => audit(false)}>重新发起</Button>,
                    <Button type="primary" onClick={() => audit(true)}>通过</Button>,
                ]}
            >
                <div style={{ padding: 10 }}>
                    <Form form={form} component={false}>
                        <YhForm formRef={formRef} {...formConfig} />
                    </Form>
                </div>
            </YHRightModal>

            <Image
                width={200}
                style={{ display: 'none' }}
                src={previewImage}
                preview={{
                    visible: previewOpen,
                    //src: previewImage,
                    onVisibleChange: value => {
                        setPreviewOpen(value);
                    },
                }}
            />
        </>
    )
}
